import {
    Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
    Table,
    Tbody,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue, useDisclosure,
} from "@chakra-ui/react";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import axios from 'axios'
import {useAuthHeader} from  'react-auth-kit'
import {
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'
import { useInfiniteQuery, } from '@tanstack/react-query'
import AdminNavbar from "../../Navbars/AdminNavbar";
import TableRatesRow from "../../TableRatesRow";
import {Link as ReactRouterLink} from 'react-router-dom'
import { Link as ChakraLink } from '@chakra-ui/react'

const fetchSize = 50

const RatesTable = ({ title, columns }) => {

    const textColor = useColorModeValue("gray.700", "white");
    const tableContainerRef = React.useRef(null)
    const [sorting, setSorting] = React.useState([])
    const token = useAuthHeader();
    const [globalFilter, setGlobalFilter] = React.useState('')
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [action, setAction] = useState(false)
    const [approve, setApprove] = useState(false)
    const [limitId, setLimitId] = useState('')
    const [resp, setResp] = useState(null)

    const refresh = () => window.location.reload(true)

    const approveAction = () => {
        setApprove(true)
        // onClose()
        // refresh()
    }

    const approveAction2 = () => {
        onClose()
        refresh()
    }

    const { data, fetchNextPage, isFetching, isLoading } =
        useInfiniteQuery(
            ["rates", sorting],
            async ({ pageParam = 0 }) => {
                const res = await axios.get(`/api/v1/fx_rate?limit=${fetchSize}&page=${pageParam+1}`, { headers: {Authorization: token() } })

                return await res.data
            },
                {
                getNextPageParam: (_lastGroup, groups) => groups.length,
            }
        )

    const flatData = useMemo(
        () => data?.pages?.flatMap(page => page) ?? [],
        [data])

    const totalFetched = flatData.length
    const totalDBRowCount = 1000

    const fetchMoreOnBottomReached = useCallback(
        (containerRefElement) => {
            if (containerRefElement) {
                const { scrollHeight, scrollTop, clientHeight } = containerRefElement
                if (
                    scrollHeight - scrollTop - clientHeight < 300 &&
                    !isFetching &&
                    totalFetched < totalDBRowCount
                ) {
                    fetchNextPage()
                }
            }
        },
        [fetchNextPage, isFetching, totalFetched, totalDBRowCount]
    )

    const table = useReactTable({
        data: flatData,
        columns,
        state: {
            sorting, globalFilter
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        enableGlobalFilter: true
    })

    const { rows } = table.getRowModel()

    useEffect(() => {
        if (action){
            setAction(false)
            onOpen()
        }
    },[action])


    if (isLoading) {
        return <>Loading...</>
    }

    return (
        <>
            <Box>
                <AdminNavbar
                    initialValue={globalFilter ?? ''}
                    onChange={e => setGlobalFilter(e)}
                    debounce={500}
                />
            </Box>
            <Box p='0px 0px 10px 0px'>
                <Text fontSize='xl' color={textColor} fontWeight='bold'>
                    {title}
                </Text>
            </Box>

            <Box p='0px 0px 10px 0px'>
                <Table color={textColor}>
                    <Thead>
                    </Thead>
                    <Tbody>
                        <Tr>
                            <td>
                                <ChakraLink color='teal.500' as={ReactRouterLink} to='/admin_area/rates/create'>
                                    Создать курс
                                </ChakraLink>
                            </td>
                            <td align={'right'}>
                                <ChakraLink color='teal.500' as={ReactRouterLink} to='/admin_area/rates/schedule'>
                                    График курса
                                </ChakraLink>
                            </td>
                        </Tr>
                    </Tbody>
                </Table>
            </Box>

            <Box overflowX="auto"
                 maxHeight={window.innerHeight - 280}
                 onScroll={e => fetchMoreOnBottomReached(e.target)}
                 ref={tableContainerRef}
            >
                <Table variant='striped' color={textColor}>
                    <Thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <Tr key={headerGroup.id} pl='0px' color='gray.400'>
                                {headerGroup.headers.map((header, idx) => {
                                    return (
                                        <Th
                                            key={header.id}
                                            color='gray.400'
                                            ps={idx === 0 ? "0px" : null}
                                            pl={idx === 0 ? "20px" : null}
                                        >
                                            <div
                                                className={
                                                    header.column.getCanSort()
                                                        ? 'cursor-pointer select-none'
                                                        : undefined
                                                }
                                                onClick={header.column.getToggleSortingHandler()}
                                            >
                                                {header.column.columnDef.header}
                                                {{
                                                    asc: ' 🔼',
                                                    desc: ' 🔽',
                                                }[header.column.getIsSorted()] ?? null}
                                            </div>
                                        </Th>
                                    )
                                })}
                            </Tr>
                        ))}
                    </Thead>
                    <Tbody>
                        {rows.map(row => {
                            return (
                                <TableRatesRow
                                    key={row.id}
                                    row={row}
                                    setActive={setAction}
                                    approveDel={approve}
                                    LimitId={setLimitId}
                                    id={limitId}
                                    respon={setResp}
                                />
                            )
                        })}
                    </Tbody>
                </Table>
                <Modal isOpen={isOpen} onClose={onClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Информация</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            {limitId
                                ? 'Хотите удалить курс ' + limitId + '?'
                                : ''
                            }
                            {resp
                                ? 'Курс удален.'
                                : ''
                            }
                        </ModalBody>
                        <ModalFooter>
                            {limitId
                                ? <Button variant='ghost' onClick={approveAction}>Да</Button>
                                : <Button variant='ghost' onClick={approveAction2}>Закрыть</Button>
                            }
                            {resp
                                ? ''
                                : <Button colorScheme='blue' onClick={onClose}>Нет</Button>
                            }

                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </Box>
            <Text>
                {flatData.length > 0
                    ? `Fetched ${flatData.length} of ${totalDBRowCount} Rows`
                    : "Ничего не найдено"
                }
            </Text>
        </>
    );
};

export default RatesTable;

